import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  alpha,
} from '@mui/material';
import { Crop } from '@mui/icons-material';

interface ImageCropDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  cropType: 'profile' | 'banner' | null;
  tempImageUrl: string | null;
  colors: any;
}

const ImageCropDialog: React.FC<ImageCropDialogProps> = ({
  open,
  onClose,
  onSave,
  cropType,
  tempImageUrl,
  colors,
}) => {
  const modalStyle = {
    borderRadius: '24px',
    bgcolor: '#0F1A15', 
    border: `1px solid ${alpha(colors.accent, 0.3)}`,
    boxShadow: '0 20px 60px rgba(0,0,0,0.7)',
    color: '#FFFFFF'
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth 
      PaperProps={{ sx: { ...modalStyle, overflow: 'hidden' } }}
    >
      <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, color: '#FFFFFF' }}>
        <Crop /> Crop {cropType === 'profile' ? 'Profile Picture' : 'Banner'}
      </DialogTitle>
      <DialogContent sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#000', position: 'relative', minHeight: 300 }}>
        {tempImageUrl && (
          <Box sx={{ position: 'relative', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={tempImageUrl} alt="Crop Preview" style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }} />
            {/* Crop Overlay - Visual only */}
            <Box sx={{
              position: 'absolute',
              top: 0, left: 0, right: 0, bottom: 0,
              bgcolor: 'rgba(0,0,0,0.5)',
              display: 'flex', justifyContent: 'center', alignItems: 'center',
              pointerEvents: 'none'
            }}>
              <Box sx={{
                width: cropType === 'profile' ? 200 : '90%',
                height: cropType === 'profile' ? 200 : 120,
                borderRadius: cropType === 'profile' ? '50%' : '0',
                border: `2px solid ${colors.accent}`,
                bgcolor: 'transparent',
                boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)',
              }} />
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, bgcolor: modalStyle.bgcolor }}>
        <Button onClick={onClose} sx={{ color: '#fff', fontWeight: 600, textTransform: 'none' }}>
          Cancel
        </Button>
        <Button 
          onClick={onSave}
          variant="contained" 
          sx={{ bgcolor: colors.accent, color: '#fff', fontWeight: 600, borderRadius: '20px', textTransform: 'none', px: 3, boxShadow: 'none' }}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropDialog;